import type { SVGProps } from "react";

/**
 * text-1
 * @category Typography
 */
export default function IconText1(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M3.75 6.25V3.75H12M20.25 6.25V3.75H12M12 3.75V20.25M12 20.25H9.75M12 20.25H14.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
